<template>
  <a href="#" @click.prevent="addToLikes" class="like-btn" :title="likeTxt">
    <img src="@/assets/images/liked.png" v-if="inLikes" />
    <img src="@/assets/images/noLike.png" v-else />
  </a>
</template>

<script>
export default {
  name: `StarSeries`,
  props: {
    series: Object,
  },

  methods: {
    addToLikes() {
      this.$store.dispatch(`addRemoveSeries`, this.series);
    },
  },

  computed: {
    inLikes() {
      const list = this.$store.state.user.mySeries.filter(obj => {
        if (`${obj}` === `${this.series.id}`) {
          return true;
        }
        return false;
      });
      if (list.length > 0) {
        return true;
      }
      return false;
    },

    likeTxt() {
      if (this.inLikes) {
        return `אני רוצה לפרוש`;
      }
      return `אני רוצה להצטרף`;
    },
  },
};
</script>

<style lang="scss">
$purple: #656b85;
$pinky: #fd7170;

.like-btn {
  .mdi {
    color: $pinky;
    &:hover {
      color: $purple;
    }
  }

  .in-likes {
    font-size: 0.8rem;
    color: $purple;
  }

  .not-in-likes {
    color: $pinky;
  }
}
</style>
